import { render } from "./B2bTableReportesRecibidos.vue?vue&type=template&id=49f2f1b3&scoped=true&lang=pug"
import script from "./B2bTableReportesRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bTableReportesRecibidos.vue?vue&type=script&lang=js"

import "./B2bTableReportesRecibidos.vue?vue&type=style&index=0&id=49f2f1b3&lang=scss&scoped=true"
import "./B2bTableReportesRecibidos.vue?vue&type=style&index=1&id=49f2f1b3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f2f1b3"]])

export default __exports__